import { crudTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * User-authored notes for a morpheme (grapheme), shown on the info page.
 *
 * One row per morpheme: the row id is derived from it (`deriveMorphemeNoteId`), so no unique index
 * is needed, and none may be added (sync cannot resolve a unique conflict).
 */
export const morphemeNoteTable = crudTable(
  "morpheme_note",
  {
    morpheme: text("morpheme").notNull(),
    text: text("text"),
  },
  (table) => [index("morpheme_note_morpheme_idx").on(table.morpheme)],
);

export type MorphemeNote = typeof morphemeNoteTable.$inferSelect;
